import React from "react";

const Footer = () => {
  return (
    <footer className="copyright">
      <p>&copy; 2020 Designed and Created by Kenneth Aladi</p>
    </footer>
  );
};

export default Footer;
